import type { ScientificObjectRef } from '../../../scientific-objects/ScientificObjectRef';
import type { ScientificObjectSummary } from '../../../scientific-objects/ScientificObjectSummary';
import { MoleculeFactsheet } from './MoleculeFactsheet';

interface MoleculeWorkspaceProps {
  readonly reference: ScientificObjectRef;
  readonly summary: ScientificObjectSummary;
}

// ADR 0017 (#904): the Molecule's object page is its factsheet. The old "Open in drawing
// workspace" link is gone -- it opened a blank canvas, not this molecule.
export function MoleculeWorkspace({ reference }: MoleculeWorkspaceProps) {
  return (
    <div className="molecule-workspace" data-object-id={reference.id}>
      <MoleculeFactsheet moleculeId={reference.id} />
    </div>
  );
}
